export const formatAmount = (amount, language) => {
    const locales = {
      English: "en-CA",
      Français: "fr-CA",
    };
  
    const currencyFormat = new Intl.NumberFormat(locales[language], {
      style: "currency",
      currency: "CAD",
    });
  
    return currencyFormat.format(amount);
  };
  
  export const formatDate = (date, language) => {
    const locales = {
      English: "en-CA",
      Français: "fr-CA",
    };
  
    const dateFormat = new Intl.DateTimeFormat(locales[language], {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  
    return dateFormat.format(new Date(date));
  };
  